



















































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TournamentAction } from '@/modules/tournament/components/TournamentBasicInformation/TournamentBasicInformation.vue'
import { TournamentEntity } from '@/api/tournament'
import { getPrizeCurrency, getPrizeValue } from '@/utils/prize'
import { date } from '@/utils'

@Component({
  filters: {
    date
  }
})
export default class TournamentCard extends Vue {
  @Prop({ default: '' }) readonly tournament!: TournamentEntity
  @Prop({ default: TournamentAction.JoinTournament })
  readonly tournamentAction!: TournamentAction

  get prizeCurrency() {
    return getPrizeCurrency(this.tournament.prizePrizePool)
  }

  get prizeValue() {
    return getPrizeValue(this.tournament.prizePrizePool)
  }

  get tournamentActionString() {
    switch (this.tournamentAction) {
      case TournamentAction.ViewTournament:
        return this.$t('TournamentBasicInformation.ViewTournament')

      case TournamentAction.ViewRegistrationStatus:
        return this.$t('TournamentBasicInformation.ViewRegistrationStatus')

      case TournamentAction.JoinTournament:
        return this.$t('TournamentBasicInformation.JoinTournament')
    }
  }
}
